<template>
   <v-card flat :color="dark" class="">
      <v-container>
        <v-card-title class="">
          <h1 class="">My Public Profile</h1>
          <v-spacer></v-spacer>
          <v-btn :color="primaryBlue" large @click="$router.push('/profile/edit')">Edit profile</v-btn>
        </v-card-title>
        <ProfileComponent :id="getSession.writer.id"/>
      </v-container>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import colorMxn from "@/mixins/colorMxn";

export default {
  name: "UploadModal",
  components: {
    ProfileComponent: () => import('./components/profileComponent'),
  },
  props: ["show"],
  mixins: [colorMxn],
  data() {
    return {
      dialogue: false,
      after: true,
      uploaded: true,
      reviews: [
        {
          review_id: 1,
          customer_slug: "56686889",
          time_posted: "18 minutes ago",
          rating: 5,
          comment:
            "Her work is amazing. I have used other writers before and needed to edit or fix things. With Amanda, I changed nothing. She even got it to me one day before it was due. I will be using her again.",
          essay_type: "Essay (any type) 1348363 on Ethics"
        },
        {
          review_id: 1,
          customer_slug: "56686889",
          time_posted: "18 minutes ago",
          rating: 5,
          comment: "",
          essay_type: "Essay (any type) 1348363 on Ethics"
        },
        {
          review_id: 1,
          customer_slug: "56686889",
          time_posted: "18 minutes ago",
          rating: 5,
          comment:
            "Her work is amazing. I have used other writers before and needed to edit or fix things. With Amanda, I changed nothing. She even got it to me one day before it was due. I will be using her again.",
          essay_type: "Essay (any type) 1348363 on Ethics"
        }
      ],
      detail: {
            "id": 1,
            "user_id": 2,
            "rating": "5",
            "total_orders": 0,
            "total_reviews": 0,
            "nickname": "writer",
            "long_about": "I have more than eight years of experience in academic writing. During my long career in essay writing, I have learned that time is the most valuable resource distributed equally to all writers. Therefore, I only write my essays after doing proper research; thus, I always deliver satisfactory work that meets my customers' expectations. My secret is that I offer projects which are ever consistent, rational, and appropriately structured. Meeting my customers' needs has been my passion throughout my academic writing.\n\nAdditionally, academic writing has enabled me to help many students worldwide achieve their educational goals. I have also learned that education is a journey that demands that everyone have a partner to help him/her to get to the destination. With some of my clients, we have been able to walk this journey until they graduated. It has encouraged me ever to be ready to step with many more students to achieve their academic prosperity.\n\nBased on my many years of writing, I am now able to write essays on various subjects. Taking time to read the instructions for an assignment forms the basis for delivering quality work. Moreover, I have enough knowledge of grammar and sentence structure, meaning my work ever meets the academic writing standards. This particular virtue has assisted me to rise to become among the most successful academic writers. Nevertheless, a strong command of the language has encouraged my clients to enjoy reading my essays. An original paper complimented by proper grammar increases the client's educational success. Therefore, all my academic papers are original and properly cited.\n\nTo ensure that I maintain the quality of the essays I write for my clients, I continuously research numerous subjects to ensure that my extensive knowledge is always replenished. Reading has been an essential resource that has enabled me to understand how I can tackle all assignments on different topics. Having prior knowledge of numerous subjects allows me to deliver my papers before the deadline hence avoiding any inconvenience caused to the customer due to a missed deadline. It means that I hold so dearly the customer's deadline. I also make all the client's corrections and amendments if something that the customer feels ought to be included. Therefore, I take this opportunity to welcome you to view my profile and offer me your projects.",
            "short_about": "An accomplished Essay writer",
            "avatar": "1624628166357_589-ID-0.jpeg",
            "state": null,
            "country": "Kenya",
            "country_code": "KE",
            "timezone": "Africa/Nairobi",
            "fraud_score": null,
            "is_online": null,
            "created_at": "2021-06-25 15:47:43",
            "updated_at": "2021-06-26 13:37:50",
            "user": {
                "id": 2,
                "username": "writer",
                "email": "writer@gmail.com",
                "user_type": 2,
                "first_name": null,
                "last_name": null,
                "dob": null,
                "phone_number": null,
                "country": "Kenya",
                "country_code": "KE",
                "timezone": "Africa/Nairobi",
                "created_at": "2021-06-25 15:47:43",
                "updated_at": "2021-06-25 15:47:43"
            }
      },
      loading: false,
    };
  },
  computed: {
		...mapGetters(['getSession']),
  },
  mounted() {
    this.getWriterProfile();
  },
  methods: {
    ...mapActions(['performGetActions']),
    async getWriterProfile() {
      this.loading = true;
      const fullPayload = {
        endpoint: `/profile/writer/${this.getSession.writer.id}`
      }

      const response = await this.performGetActions(fullPayload);
      this.loading = false;
      this.detail = response.data[0];
    }
  },
};
</script>

<style scoped>
.word-break {
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
